import { jsx } from "react/jsx-runtime";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { validateTidalLicense } from "../../base/index.js";
function DateRange(props) {
  return /* @__PURE__ */ jsx(
    DateRangeIcon,
    {
      "data-testid": "DateRange",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DateRange",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
DateRange.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "DateRange"
};
validateTidalLicense();
export {
  DateRange
};
//# sourceMappingURL=DateRange.js.map
